/* eslint-disable consistent-return */
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export type LocationSnapshotType = {
  url: string;
  time: Date;
};

export default function useLocationChange(
  onLocationChange: (
    previousSnapshot: LocationSnapshotType,
    currentSnapshot: LocationSnapshotType | null
  ) => void
) {
  const location = useLocation();
  const [snapshot, setSnapshot] = useState<LocationSnapshotType | null>(null);

  useEffect(() => {
    if (!snapshot) {
      setSnapshot({
        url: location.pathname,
        time: new Date()
      });
      return;
    }

    if (location.pathname === snapshot?.url) return;

    const newSnapshot = {
      url: location.pathname,
      time: new Date()
    };
    onLocationChange(snapshot, newSnapshot);
    setSnapshot(newSnapshot);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(
    () => () => {
      if (snapshot) {
        onLocationChange(snapshot, null);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
